import { render } from "./DashboardMoneyballStickModal.vue?vue&type=template&id=44b8f56a"
import script from "./DashboardMoneyballStickModal.vue?vue&type=script&lang=js"
export * from "./DashboardMoneyballStickModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__